/**
 * The store's payment-mode disclosure (GATE-2026-07-15-stripe-payments CF-3; the owner's `A-082`
 * answer 1a, AD-701). Pure so the label is pinned by a test, not by a grep (F3 gate r2 K22): in
 * stub mode the player is told the top-up charges nothing AND that what they hold is TEST Gleam
 * the launch wipe voids; any other mode — live, or not yet known — says nothing rather than lie.
 */

export const STUB_DISCLOSURE =
  ' Payment provider is a stub — top-up settles without charging (dev/test only). This is TEST Gleam: the launch wipe voids whatever is left of it (AD-701).';

export function storeModeDisclosure(mode: string | null | undefined): string {
  return mode === 'stub' ? STUB_DISCLOSURE : '';
}
